// React
import React from "react";

// Constants
import { APP_NAME } from "@/constants/constants";

// Components
// import { Link } from "react-router-dom";

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="text-muted-foreground flex flex-col items-center justify-center gap-1 p-2 text-sm md:flex-row md:gap-5 md:px-6 md:py-3">
      <div>
        &copy; {currentYear} {APP_NAME}.
      </div>
      {/* <div className="flex items-center gap-4">
        <Link to="/terms" className="hover:text-foreground transition-colors">
          Terms
        </Link>
        {" · "}
        <Link to="/privacy" className="hover:text-foreground transition-colors">
          Privacy
        </Link>
      </div> */}
    </footer>
  );
};

export default Footer;
